import { useState, useCallback, useEffect } from "react";
export var useIphoneX = function () {
  var _a = useState(false),
      isIphonex = _a[0],
      setIsIphonex = _a[1];

  var isIOS = useCallback(function () {
    return navigator.userAgent.match(/(iPhone|iPod|iPad)/i);
  }, []);
  var isIphoneX = useCallback(function () {
    try {
      if (isIOS()) {
        if (window.screen.height >= 812) {
          return true;
        }
      }
    } catch (error) {
      console.log(error);
    }

    return false;
  }, []);
  useEffect(function () {
    setIsIphonex(isIphoneX());
  }, []);
  return [isIphonex];
};